import { render, staticRenderFns } from "./butiebaobiao.vue?vue&type=template&id=21587068&scoped=true"
import script from "./butiebaobiao.vue?vue&type=script&lang=js"
export * from "./butiebaobiao.vue?vue&type=script&lang=js"
import style0 from "./butiebaobiao.vue?vue&type=style&index=0&id=21587068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21587068",
  null
  
)

export default component.exports